import React, { useContext, useState, useEffect } from "react";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import "../style.scss";
import {
  FILTER__FORM_FIELDS_GLOBAL,
  FILTER__FORM_FIELDS,
  IssuanceIDCardContext,
  PAGE_STATE,
} from "../contextApi";
import {
  getAcademicCareerId,
  useGetBatchListByBuAcadGroupTermCourseId,
  useGetCourseIdList,
} from "../../issuanceIDcard/customhooks";
import { packageCodeDropdown } from "../materialDistribution/helper";

export function extractBufferDays(config) {
  const DEFAULT_DAYS = 30;

  const parseDays = (dayString) => {
    const match = dayString?.match(/(\d+)\s*day/);
    return match ? parseInt(match[1], 10) : DEFAULT_DAYS;
  };

  const startDateBufferDay = parseDays(config?.daysBeforeStart);
  const endDateBufferDay = parseDays(config?.daysBeforeEnd);

  return { startDateBufferDay, endDateBufferDay };
}

const StudentFilterForm = ({ disabled, issuanceConfig }) => {
  const inputHeight = "42px";
  const marginTop = { marginTop: "33px" };

  const {
    dropdown,
    filterForm,
    setFilterForm,
    setPage,
    setCurrentPageState,
    setGlobalFilter,
    setSelectedBusinessArea,
  } = useContext(IssuanceIDCardContext);

  const [isError, setIsError] = useState({
    businessArea: null,
    academicGroup: null,
    batchIds: null,
    courseId: null,
    academicCareer: null,
    term: null,
    categoryDispValue: null,
  });

  const [isShowError, setShowError] = useState(false);
  const [academicCareerDropdown, setAcademicCareerDropdown] = useState([]);
  const bufferDays = extractBufferDays(issuanceConfig);
  const batchDropdown = useGetBatchListByBuAcadGroupTermCourseId(
    // dropdown?.businessAreas?.length === 1
    //   ? dropdown?.businessAreas[0]
    //   : filterForm?.businessArea,
    filterForm?.businessArea,
    filterForm?.academicGroup,
    filterForm?.term,
    filterForm?.courseId
  );

  const courseIdDropdown = useGetCourseIdList(
    filterForm?.businessArea,
    filterForm?.academicGroup,
    filterForm?.term,
    // filterForm?.corpValues,
    filterForm?.academicCareer,
    bufferDays
  );

  useEffect(() => {
    if (dropdown?.academicCareer && filterForm?.businessArea) fetchDropdown();
  }, [filterForm?.businessArea]);

  async function fetchDropdown() {
    const response = await getAcademicCareerId({
      buCode: filterForm?.businessArea.value,
    });

    const options = dropdown?.academicCareer?.filter((obj) =>
      response.includes(obj.value)
    );

    setAcademicCareerDropdown(options);

    setFilterForm((prev) => ({
      ...prev,
      ["academicCareer"]: options?.[0] || "",
    }));
  }

  const resetButtonHandler = () => {
    setFilterForm(FILTER__FORM_FIELDS);
  };

  const formHandler = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
    setShowError(false);
    setIsError((prev) => ({ ...prev, [key]: null }));
  };

  const callBack = () => {
    setCurrentPageState(PAGE_STATE.SELECT_MATERIAL);
  };

  const isBatchDisabled = () => {
    // if (dropdown?.businessAreas?.length === 1) {
    //   return (
    //     dropdown?.businessAreas?.length === 1 && (filterForm?.term.length === 0 || !filterForm?.academicGroup || !filterForm?.courseId?.length)
    //   );
    // } else {
    return (
      filterForm?.term.length === 0 ||
      filterForm?.businessArea === "" ||
      !filterForm?.academicGroup ||
      !filterForm?.courseId?.length
    );
    // }
  };

  const isErrorExist = (formFields) => {
    let isFindError = false;
    for (const key in formFields) {
      if (key !== "corpValues" && filterForm[key]?.length === 0) {
        formFields[key] = true;
        isFindError = true;
        setShowError(true);
      } else {
        formFields[key] = null;
      }
    }
    setIsError(formFields);
    return isFindError;
  };
  const nextButtonHandler = () => {
    if (isErrorExist({ ...isError })) return;

    setSelectedBusinessArea(filterForm?.businessArea);
    setGlobalFilter(FILTER__FORM_FIELDS_GLOBAL);
    setPage(0);
    formHandler("bufferDays", bufferDays);
    callBack();
  };

  const errorBorder = { border: "1px solid red", color: "red" };

  return (
    <div>
      <div
        className="student-search-filer-stock 
      my-2"
      >
        <div>
          <AAutoComplete
            label="Business area*"
            height={inputHeight}
            placeholder="Business area"
            isMulti={false}
            items={dropdown?.businessAreas}
            currentValue={filterForm?.businessArea}
            isDisabled={disabled}
            handleChange={(value) => {
              formHandler("businessArea", value);
              formHandler("batchIds", []);
              formHandler("courseId", []);
            }}
            style={{ control: isError["businessArea"] ? errorBorder : {} }}
          />
        </div>
        <div>
          <AAutoComplete
            height={inputHeight}
            label="Academic group*"
            placeholder="Academic group"
            items={dropdown?.academicGroups}
            currentValue={filterForm?.academicGroup}
            isShowCount={true}
            handleChange={(value) => {
              formHandler("academicGroup", value);
              formHandler("courseId", []);
              formHandler("batchIds", []);
            }}
            isDisabled={disabled}
            isMulti={false}
            style={{ control: isError["academicGroup"] ? errorBorder : {} }}
          />
        </div>
        <div>
          <AAutoComplete
            label="Term*"
            height={inputHeight}
            placeholder="Term"
            items={dropdown?.terms}
            currentValue={filterForm?.term}
            isShowCount={false}
            isMulti={false}
            handleChange={(value) => {
              formHandler("term", [value]);
              formHandler("batchIds", []);
              formHandler("courseId", []);
            }}
            isDisabled={disabled}
            style={{ control: isError["term"] ? errorBorder : {} }}
          />
        </div>

        {/* <div>
          <AAutoComplete
            height={inputHeight}
            label="CORP Course Attribute Value"
            placeholder="CORP Value"
            isShowCount
            isMulti
            items={dropdown?.corpValues}
            currentValue={filterForm?.corpValues}
            handleChange={(value) => {
              formHandler("corpValues", value);
              formHandler("courseId", []);
              formHandler("batchIds", []);
            }}
            isDisabled={disabled}
            //non-mandatory: style={{ control: isError["corpValues"] ? errorBorder : {} }}
          />
        </div>

        {/* Academic Career based on BU */}
        <div>
          <AAutoComplete
            label="Academic career*"
            height={inputHeight}
            placeholder="Academic career"
            items={academicCareerDropdown}
            currentValue={filterForm?.academicCareer}
            isShowCount={false}
            isMulti={false}
            handleChange={(value) => {
              formHandler("academicCareer", value);
              formHandler("courseId", []);
              formHandler("batchIds", []);
            }}
            isDisabled={!filterForm.businessArea || disabled}
            style={{ control: isError["academicCareer"] ? errorBorder : {} }}
          />
        </div>
        <div>
          <AAutoComplete
            height={inputHeight}
            label="Course ID*"
            placeholder="Course ID"
            isShowCount
            isMulti
            items={courseIdDropdown}
            currentValue={filterForm?.courseId}
            handleChange={(value) => {
              formHandler("batchIds", []);
              formHandler("courseId", value);
            }}
            isDisabled={
              !filterForm.businessArea ||
              !filterForm.academicGroup ||
              !filterForm.academicCareer ||
              !filterForm.term.length > 0 ||
              disabled
            }
            style={{ control: isError["courseId"] ? errorBorder : {} }}
          />
        </div>
        <div>
          <AAutoComplete
            height={inputHeight}
            label="Batch*"
            placeholder="Batch"
            items={batchDropdown}
            currentValue={filterForm?.batchIds}
            isShowCount={true}
            handleChange={(value) => {
              formHandler("batchIds", value);
            }}
            style={{ control: isError["batchIds"] ? errorBorder : {} }}
            isDisabled={isBatchDisabled() || disabled}
          />
        </div>
        {/* categoryDispValue */}
        <div>
          <AAutoComplete
            label="Pkg. Code*"
            height={inputHeight}
            placeholder="Pkg. Code"
            items={packageCodeDropdown}
            currentValue={filterForm?.categoryDispValue}
            isShowCount={true}
            isMulti={true}
            handleChange={(value) => {
              formHandler("categoryDispValue", value);
            }}
            isDisabled={disabled}
            style={{ control: isError["categoryDispValue"] ? errorBorder : {} }}
          />
        </div>
        <div style={marginTop} className="d-flex">
          <AButton
            className="button_remove_left_margin"
            updatedStyle={{ fontSize: "14px", flex: "1.75" }}
            onClick={nextButtonHandler}
            variant="primary_filled"
            disabled={disabled}
          >
            Next
          </AButton>
          <AButton
            updatedStyle={{ fontSize: "14px", flex: "0.75" }}
            onClick={resetButtonHandler}
            variant="outline"
            disabled={disabled}
          >
            Reset
          </AButton>
        </div>
      </div>
      {isShowError && (
        <span className="error-psid">All fields are required*</span>
      )}
    </div>
  );
};

export default StudentFilterForm;
